import React, { useContext, useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import ReportInfoToolbar from '@nile/reports/src/modules/reports/components/subpages/ReportToolbar/ReportInfoToolbar';
import ReportHeader from '@nile/reports/src/modules/reports/components/subpages/ReportHeader';
import ReportFilter from '@nile/reports/src/modules/reports/components/subpages/ReportFilter';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import {
  EDIT_MODE,
  VIEW_MODE,
  CREATE_MODE,
  REPORTS,
  EFFICIENCY_REPORT,
  PDF_REPORT
} from '@nile/reports/src/modules/home/constants';
import {
  Button,
  DisplayText,
  Heading,
  TextStyle
} from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { AppContext, getBrowserType } from '@nile/components';
import { savePersonalization, getPersonalization } from '@nile/graphql';
import moment from 'moment';

const ReportTvToolbar = (props) => {
  const {
    handleSave,
    errors,
    submitActionLoading,
    history,
    reportType,
    activeViewName,
    isNonAuth
  } = props;
  const reportsContext = useContext(ReportsContext);
  const tabContext = useContext(TabContext);
  const appContext = useContext(AppContext);
  const intervalRef = useRef(null);
  const [lastUpdatedTime, setLastUpdatedTime] = useState(
    moment().format('H:mm:ss')
  );
  const browserType = getBrowserType();

  const getDarkTheme = (currUser) => {
    getPersonalization({
      userId: currUser?.userId,
      name: 'Theme',
      category: 'TVDashboardPersonalization'
    })
      .then((response) => {
        if (response) {
          const res = response?.data?.getPersonalizationByCategoryAndName;
          if (res !== null) {
            appContext?.setDarkTheme(JSON.parse(res?.value)?.darkTheme);
          } else {
            // appContext?.setDarkTheme(JSON.parse(res?.value)?.darkTheme);
          }
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    // getDarkTheme(appContext?.user);
    if (props.match.path?.startsWith('/tvView') && window.Intercom) {
      window.Intercom('shutdown');
    }
    if (
      props.match.path?.startsWith('/tvView') &&
      document.getElementsByClassName('intercom-app')?.[0]
    ) {
      document.getElementsByClassName('intercom-app')[0].style.visibility =
        'hidden';
    }
    if (
      props.match.path?.startsWith('/tvView') &&
      document.getElementsByClassName('intercom-lightweight-app')?.[0]
    ) {
      document.getElementsByClassName(
        'intercom-lightweight-app'
      )[0].style.visibility = 'hidden';
    }
    browserType !== 'Apple Safari' && appContext?.setDarkTheme(true);
  }, []);

  const autorefetch = () => {
    console.log('reftching at', moment().format('H:mm:ss'));
    setLastUpdatedTime(moment().format('H:mm:ss'));
    reportsContext.setRefreshWidget(true);
  };

  useEffect(() => {
    console.log(
      'refteshratee-->>',
      reportsContext.tvRefreshRate,
      reportsContext.isTvDashboardEnabled
    );
    if (reportsContext.isTvDashboardEnabled && reportsContext.tvRefreshRate) {
      intervalRef.current = setInterval(
        autorefetch,
        reportsContext.tvRefreshRate * 60000
      );
    }
    // console.log('i', intervalRef.current);

    ///clearing interval on rerender
    return () => {
      if (intervalRef.current) {
        // console.log('im cklearrrrr', intervalRef.current);
        clearInterval(intervalRef.current);
      }
    };
  }, [reportsContext.isTvDashboardEnable, reportsContext.tvRefreshRate]);

  const handleThemeChange = (val) => {
    appContext?.setDarkTheme(val);
    const currentUser = appContext?.user || {};
    const user = {
      firstName: currentUser.firstName,
      userId: currentUser.userId,
      email: currentUser.email,
      lastName: currentUser.lastName
    };
    const personalisedData = {
      name: 'Theme',
      category: 'TVDashboardPersonalization',
      value: JSON.stringify({ darkTheme: val }),
      user: user
    };
    savePersonalization({
      variables: personalisedData,
      input: personalisedData
    });
  };

  const checkDateFilter = () => {
    return reportType !== PDF_REPORT;
  };

  const notViewMode =
    reportsContext.reportViewMode === EDIT_MODE ||
    reportsContext.reportViewMode === CREATE_MODE;

  const getReportFilterVisiblity = () => {
    return !notViewMode && reportType !== PDF_REPORT;
  };

  // hide filter if non auth token present
  const showReportFilter = getReportFilterVisiblity() && !isNonAuth;

  return (
    <div className="fx actr h100 bg-white p20 divider">
      {notViewMode ? (
        <ReportHeader
          activeView={reportsContext.activeSection.data}
          errors={errors}
          isViewOnly={reportsContext.reportViewMode === VIEW_MODE}
        />
      ) : (
        // <ReportInfoToolbar
        //   toggleNavMenu={() =>
        //     reportsContext.setNavOpen(!reportsContext.navOpen)
        //   }
        //   context={reportsContext}
        //   activeView={reportsContext.activeSection.data}
        //   reportType={reportType}
        //   activeViewName={activeViewName}
        //   lastUpdatedTime={lastUpdatedTime}
        //   isTvDashboard={reportsContext?.isTvDashboard}
        // />
        <div className="flex">
          <Heading element="h1">
            <div className="flex">
              <div className="ml-64">
                <div className={`flex actr  wm-700`}>
                  <div className="ellipsis cursor-default">
                    {reportsContext.activeSection.data?.reportType ===
                    EFFICIENCY_REPORT ? (
                      <FormattedMessage
                        id={reportsContext.activeSection.data?.name || ''}
                      />
                    ) : (
                      reportsContext.activeSection.data?.name
                    )}
                  </div>
                </div>

                <div className="fx actr ml4">
                  <DisplayText size="medium">
                    {' '}
                    <TextStyle variation="subdued">
                      <FormattedMessage id="admin.home.lastUpdatedAt" />{' '}
                      {lastUpdatedTime}
                    </TextStyle>
                  </DisplayText>
                  {reportType === REPORTS && (
                    <div className="ml-12">
                      <Button
                        size="tiny"
                        disabled={reportsContext.refreshWidget}
                        plain
                        onClick={() => {
                          setLastUpdatedTime(moment().format('H:mm:ss'));
                          reportsContext.setRefreshWidget(true);
                        }}
                        icon={<SVGIcon name="RotateRefreshLoading" size="sm" />}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Heading>
        </div>
      )}
      <div className="flex f11 jend actr g10">
        {/* {reportsContext?.isTvDashboard && (
          <div className="fx actr">
            <DisplayText size="medium">
              {' '}
              <TextStyle variation="subdued">
                <FormattedMessage id="admin.home.lastUpdatedAt" />{' '}
                {lastUpdatedTime}
              </TextStyle>
            </DisplayText>
          </div>
        )} */}
        {showReportFilter && (
          <ReportFilter
            reportType={reportType}
            showSite={false}
            showDateFilter={checkDateFilter()}
            showClient={reportType !== EFFICIENCY_REPORT}
          />
        )}
        <Button
          icon={<SVGIcon name="FullScreen" />}
          onClick={() => {
            var docElm = document.documentElement;
            if (!document.fullscreenElement) {
              if (docElm.requestFullscreen) {
                docElm.requestFullscreen();
              } else if (docElm.msRequestFullscreen) {
                docElm.msRequestFullscreen();
              } else if (docElm.mozRequestFullScreen) {
                docElm.mozRequestFullScreen();
              } else if (docElm.webkitRequestFullScreen) {
                docElm.webkitRequestFullScreen();
              }
            } else {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
              } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
              }
            }
          }}
        />
        {/* {browserType !== 'Apple Safari' && (
          <div
            onClick={() => {
              handleThemeChange(!appContext?.darkTheme);
            }}
          >
            <Button
              icon={
                appContext?.darkTheme ? (
                  <SVGIcon name="Sun" />
                ) : (
                  <SVGIcon name="Moon" />
                )
              }
            />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default withRouter(ReportTvToolbar);
